import { Store, USER } from '@/store'
import { LOGIN_VIEW, VIEWER_VIEW } from '@/router'
import { APP_REDIRECT_ON_LOGIN } from '@/enviroment/app'
import services from '@/services'
import { LOGIN_REDIRECTION_QUERY, LOGIN_REDIRECTION_NAME } from '@/views/Login/Index'

export default async function auth ({ next, router, to }) {
  const connections = await services.connection.getConnections()
  if (to.name === LOGIN_VIEW && Object.keys(Store.getters[USER.GETTERS.GET_ALL_USERS]()).length === connections.length) {
    return router.push({ name: to.query[LOGIN_REDIRECTION_NAME] || VIEWER_VIEW, params: { id: to.query[LOGIN_REDIRECTION_QUERY] || APP_REDIRECT_ON_LOGIN } })
  } else if (to.name !== LOGIN_VIEW && Object.keys(Store.getters[USER.GETTERS.GET_ALL_USERS]()).length < connections.length) {
    let query = {}
    query[LOGIN_REDIRECTION_QUERY] = to.params.id
    query[LOGIN_REDIRECTION_NAME] = to.name
    return router.push({ name: LOGIN_VIEW, params: {}, query })
  }
  return next()
}
